import React, { useCallback, useEffect, useRef } from 'react';
export const FocusTrap = ({ children, active = true, onDeactivate }) => {
    const trapRef = useRef(null);
    const previousActiveElement = useRef(null);
    const getFocusableElements = useCallback(() => {
        if (!trapRef.current) {
            return [];
        }
        const focusableSelectors = [
            'a[href]',
            'button',
            'input',
            'textarea',
            'select',
            '[tabindex]:not([tabindex="-1"])',
        ].join(', ');
        return Array.from(trapRef.current.querySelectorAll(focusableSelectors));
    }, []);
    const handleTabKey = useCallback((event) => {
        const focusableElements = getFocusableElements();
        if (focusableElements.length === 0) {
            return;
        }
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey) {
            if (document.activeElement === firstElement) {
                event.preventDefault();
                lastElement.focus();
            }
        }
        else {
            if (document.activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        }
    }, [getFocusableElements]);
    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Tab') {
            handleTabKey(event);
        }
        else if (event.key === 'Escape' && onDeactivate) {
            onDeactivate();
        }
    }, [handleTabKey, onDeactivate]);
    useEffect(() => {
        if (active) {
            previousActiveElement.current = document.activeElement;
            const focusableElements = getFocusableElements();
            if (focusableElements.length > 0) {
                focusableElements[0].focus();
            }
            document.addEventListener('keydown', handleKeyDown);
        }
        else {
            document.removeEventListener('keydown', handleKeyDown);
            if (previousActiveElement.current) {
                previousActiveElement.current.focus();
            }
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [active, getFocusableElements, handleKeyDown]);
    return React.createElement("div", { ref: trapRef }, children);
};
//# sourceMappingURL=FocusTrap.js.map